import Select from "react-select";
import React, { useState } from "react";
import { ReactComponent as DownArrow } from "../../images/navdownarrow-10px-12px.svg";
import styled from 'styled-components';

const DropdownWrapper = styled.div`
    width: ${(props) => props.width};
    color: ${(props) => props.color};
    box-sizing: border-box;
    position: relative;
`

const OptionWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    height: ${(props) => props.optionHeight};
    cursor: pointer;
    &:hover {
        background-color:${(props) => props.selectedOptionBgColor};
    }
`;

const SelectedOptionWrapper = styled(OptionWrapper)`
    background-color: ${(props) => props.selectedOptionBgColor};
`;

const OptionText = styled.p`
    padding: 0;
    margin: 0;
    font-size: ${(props) => props.optionFontSize};
`;

const BulletPoint = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${(props) => props.bulletSize};
    height: 16px;
    width: 16px;
    color: ${(props) => props.bulletColor};
`;
const MenuButton = styled.div`
    width: 100%;
    cursor: pointer;
    font-size: 16px;
    line-height: 19px;
    height: ${(props) => props.height};
    background: #FFFFFF;
    white-space: nowrap;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-color: ${(props) => props.borderColor};
    border-width: ${(props) => props.borderWidth};
    border-style: ${(props) => props.borderStyle};
    border-radius: ${(props) => props.borderRadius};
    `

const MenuText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    white-space: nowrap;
    padding-left: 15px;
    text-indent: ${(props) => props.valueTextIndent};
`

const MenuArrowContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 10%;
    box-sizing: border-box;
`


const highlightColor = '#dfe6ed';
const disabledFontColor = '#74787d';
const fontColor = '#2f2f30';

export default function SearchSelect(props) {

    let width = props.width ? props.width : '100%';
    let height = props.height ? props.height : '48px';
    let color = props.color ? props.color : fontColor;
    let valueTextIndent = props.valueTextIndent ? props.valueTextIndent : '0px';
    let placeholderText = props.placeholderText ? props.placeholderText : 'Select';
    let arrowPositionFromRight = props.arrowPositionFromRight ? props.arrowPositionFromRight : '0px';
    let arrowPositionFromBottom = props.arrowPositionFromBottom ? props.arrowPositionFromBottom : '0px';
    let borderColor = props.borderColor ? props.borderColor : 'black';
    let borderWidth = props.borderWidth ? props.borderWidth : '1px';
    let borderStyle = props.borderStyle ? props.borderStyle : 'solid';
    let borderRadius = props.borderRadius ? props.borderRadius : '4px';

    //Option specific styles - If any styles are added they need to be updated in the Select component styleProps
    let optionHeight = props.optionHeight ? props.optionHeight : '35px';
    let optionFontSize = props.optionFontSize ? props.optionFontSize : '16px';
    let selectedOptionBgColor = props.selectedOptionBgColor ? props.selectedOptionBgColor : highlightColor;
    let bulletSize = props.bulletSize ? props.bulletSize : '16px';
    let bulletColor = props.bulletColor ? props.bulletColor : color;

    //Searchbar styles
    let searchBarHeight = props.searchBarHeight ? props.searchBarHeight : 'max-content';
    let searchBarFontSize = props.searchBarFontSize ? props.searchBarFontSize : optionFontSize;
    let searchBarPlaceholderText = props.searchBarPlaceholderText ? props.searchBarPlaceholderText : 'Search';
    let searchBarPlaceholderColor = props.searchBarPlaceholderColor ? props.searchBarPlaceholderColor : disabledFontColor;

    const [isOpen, setIsOpen] = useState(false);

    function toggleOpen() {
        setIsOpen(!isOpen)
    }
    
    const customStyles = {
        menu: (provided, state) => {
            return {
            ...provided, 
            width: width, 
            boxShadow: 'none', 
            position: 'initial'
        }},
        option: (provided, state) => {
            return {
            ...provided, 
            width: width
        }},
        //control is the search bar component
        control: (provided, state) => {
            return {
            borderColor: "black", 
            borderWidth: '1px', 
            borderStyle: 'solid', 
            borderRadius: '4px',
            margin: '5px', 
            cursor: 'pointer', 
            outline: 'none!important', 
            height: searchBarHeight, 
            fontSize: searchBarFontSize, 
        }},
        //input is also the part of the searchbar 
        input: (provided, state) => {
            return {
                ...provided,
                color: color
            }
        },
        //placeholder is the text in searchbar when nothing has been typed
        placeholder: (provided, state) => {
            return {
            ...provided,
            color: searchBarPlaceholderColor,
            paddingLeft: '2px',
        }},
        dropdownIndicator: (provided, state) => {
            return {
            ...provided, 
            marginRight: "10px", 
            color: color
        }},
    }
    
    
        const CustomOption = (props) => {
            const {data, isSelected, innerProps, isDisabled, selectProps } = props;
            //Need to update the selectProps in order to access the styles within the styled components
            selectProps.styleProps.selectedOptionBgColor = isDisabled ? 'white' : selectedOptionBgColor;
            selectProps.styleProps.color = isDisabled ? disabledFontColor : color;
        
            return ((isSelected) ?
                //className is not used for styling but is used for the scrollToSelected function
                <SelectedOptionWrapper className='selectedOption' {...selectProps.styleProps}>
                    <BulletPoint {...selectProps.styleProps}>•</BulletPoint>
                    <OptionText {...selectProps.styleProps}>{data.label}</OptionText>
                </SelectedOptionWrapper>
                :
                <OptionWrapper {...innerProps} {...selectProps.styleProps}>
                    <BulletPoint {...selectProps.styleProps}> </BulletPoint>
                        <OptionText {...selectProps.styleProps}>{data.label}</OptionText>
                </OptionWrapper>
            )
        }
    
        function handleChange(e) {
            toggleOpen()
            if(props.onChange) {
                props.onChange(e)
            }
        }
    
        function scrollToSelected() {
            setTimeout(() => {
                const selectedEl = document.getElementsByClassName("selectedOption")[0];
                if (selectedEl) {
                    selectedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                }
            }, 15);
        };
    
        return (
        <Dropdown
            isOpen={isOpen}
            onClose={toggleOpen}
            scrollToSelected={scrollToSelected()}
            width={width}
            color={color}
            target={
                <MenuButton 
                    height={height}
                    onClick={toggleOpen}
                    borderColor={borderColor}
                    borderRadius={borderRadius}
                    borderWidth={borderWidth}
                    borderStyle={borderStyle}
                    >
                    <MenuText valueTextIndent={valueTextIndent}>
                        {props.value ? props.value.label : placeholderText}
                    </MenuText>
                    <MenuArrowContainer>
                        <CustomArrow arrowPositionFromRight={arrowPositionFromRight} arrowPositionFromBottom={arrowPositionFromBottom} />
                    </MenuArrowContainer>
                </MenuButton>
        }>
                <Select
                    {...props}
                    autoFocus
                    closeMenuOnSelect
                    backspaceRemovesValue={false}
                    menuIsOpen
                    controlShouldRenderValue={false}
                    tabSelectsValue={false}
                    hideSelectedOptions={false}
                    styles={customStyles}
                    placeholder={searchBarPlaceholderText}
                    value={props.value ? props.value : ''}
                    styleProps={{
                        bulletSize: bulletSize,
                        bulletColor: bulletColor,
                        optionHeight: optionHeight,
                        optionFontSize: optionFontSize
                    }}
                    onChange={(e) => handleChange(e)}
                    options={props.options ? props.options : [{label: 'No Options', value: 'N/A'}]}
                    components={{
                        Option: CustomOption,
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                        ClearIndicator: () => null
                    }}
                />
            </Dropdown>
        )
    }
    
    //**Components used/needed for search bar to work properly
    const Blanket = (props) => (
        <div
            style={{
                bottom: 0,
                left: 0,
                top: 0,
                right: 0,
                position: 'fixed',
                zIndex: 1,
            }}
            {...props}
        />
    );
    const Menu = (props) => {
        const shadow = 'hsla(218, 50%, 10%, 0.1)';
        return (
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: 4,
                    boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
                    marginTop: 8,
                    position: 'absolute',
                    zIndex: 2,
                    width: props.width
                }}
                {...props}
            />
        );
    };
    const Dropdown = ({
        children,
        isOpen,
        target,
        onClose,
        scrollToSelected,
        width,
        color
    }) => (
        <DropdownWrapper 
            color={color}
            width={width} 
            onClick={() => !isOpen ? scrollToSelected : null}
        >
            {target}
            {isOpen ? <Menu width={width}>{children}</Menu> : null}
            {isOpen ? <Blanket onClick={onClose} /> : null}
        </DropdownWrapper>
    );

    const CustomArrow = (props) => {
        return (
            <DownArrow 
                style={{
                cursor: 'pointer',
                height: '100%',
                width: '14px',
                position: 'relative',
                bottom: props.arrowPositionFromBottom,
                right: props.arrowPositionFromRight
            }}/>
        )
}
    